import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Label } from '../../classes/label';
import { environment } from 'src/environments/environment';
import { HandleError } from '../../utils/handler-error';
import { ResponseData } from '../../utils/response';

@Injectable({ providedIn: 'root' })
export class LabelService {
  constructor(private http: HttpClient) {}

  public findLabels(): Observable<ResponseData<Label[]>> {
    return this.http.get<ResponseData<Label[]>>(`${environment.API}/label`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public createLabel(label: Label): Observable<ResponseData<Label>> {
    return this.http
      .post<ResponseData<Label>>(`${environment.API}/label`, label)
        .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public updateLabel(label: Label): Observable<ResponseData<Label>> {
    return this.http
      .put<ResponseData<Label>>(`${environment.API}/label`, label)
        .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public deleteLabel(label: Label): Observable<ResponseData<Label>> {
    return this.http
      .delete<ResponseData<Label>>(`${environment.API}/label/${label.id}`)
        .pipe(catchError(HandleError.handlerErrorObservable));
  }
}
